module.exports = __webpack_public_path__ + "img/resolve_after_fr.49ef403f.svg";